
export default {
    name: 'JsonForm',

    props: {
        model: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            loading: false,
            form: {},
        }
    },

    methods: {

        buildModel() {
            if (this.model && this.model.fields) {
                this.model.fields.forEach(field => {
                    if (field.key) {
                        this.$set(this.form, field.key, field.default || '')
                    }
                })
            }
        },

        submit() {
            this.loading = true
            if (this.model && (this.model.type == 'register' || this.model.type == 'vendor-register')) {
                const data = this.model.fields.reduce((acc, field) => {
                    if (field.key) {
                        if (field.key.includes('.')) {
                            const [key, subkey] = field.key.split('.')
                            if (!acc[key]) acc[key] = {}
                            acc[key][subkey] = this.form[field.key]
                        } else acc[field.key] = this.form[field.key]
                    }
                    return acc
                }, {})
                if (this.model.type == 'vendor-register')
                    data.is_vendor = true
                this.$store.dispatch('user/register', data)
                    .then(() => {
                        if (this.model.klaviyo_event) {
                            try {
                                this.$store.dispatch('klaviyo/event', this.model.klaviyo_event)
                            } catch (e) { }
                        }
                        if (this.model.fb_event)
                            this.$track(this.model.fb_event.name, this.model.fb_event.data || {})
                        this.$track('Register')
                        this.$trackEvent('REGISTER')
                        try {
                            this.$trackConnect()
                        } catch (e) { }
                        this.$trackEvent('LOGIN')
                        if (this.model.after)
                            this.$router.push(this.model.after)
                    })
                    .catch(() => { })
                    .finally(() => {
                        this.loading = false
                    })
            } else {
                this.loading = false
            }
        },
    },

    mounted() {
        this.buildModel()
    }
}
